import styled from "styled-components";

export const IntroText = styled.p`
  font-size: 1rem;
  line-height: 1.7;
  color: var(--neutral);
  margin: 0 0 40px 0;
  max-width: 760px;
`;

export const TreeContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 40px;
`;

export const GroupCard = styled.div`
  border: 1px solid var(--gray-light);
  border-radius: 8px;
  overflow: hidden;
  background: white;
`;

export const GroupHeader = styled.div<{ $expandable: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 20px;
  cursor: ${(props) => (props.$expandable ? "pointer" : "default")};
  background-color: var(--gray-lightest);

  &:hover {
    background-color: ${(props) => (props.$expandable ? "rgba(37, 99, 235, 0.06)" : "var(--gray-lightest)")};
  }
`;

export const GroupTitle = styled.button`
  all: unset;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.0625rem;
  font-weight: 700;
  color: var(--neutral);
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid var(--primary);
    outline-offset: 2px;
  }
`;

export const ToggleIcon = styled.img<{ $expanded: boolean }>`
  width: 14px;
  height: 14px;
  transition: transform 0.2s ease;
  transform: rotate(${(props) => (props.$expanded ? "180deg" : "0deg")});
`;

export const ItemCount = styled.span`
  font-size: 0.8125rem;
  font-weight: 500;
  color: var(--neutral-light);
  background: white;
  border: 1px solid var(--gray-light);
  border-radius: 999px;
  padding: 2px 10px;
`;

export const ItemsList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 8px 20px 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ItemLink = styled.a`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  padding-left: 32px;
  border-radius: 6px;
  color: var(--primary);
  text-decoration: none;
  font-size: 0.9375rem;
  cursor: pointer;

  &:hover {
    background-color: rgba(37, 99, 235, 0.06);
    text-decoration: underline;
  }

  &::before {
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: var(--primary-light);
    flex-shrink: 0;
  }
`;

export const ExternalMark = styled.span`
  font-size: 0.75rem;
  color: var(--neutral-light);
  font-weight: 500;
`;
